<template>
 <b-container fluid class="container-md">

     <div class="hotels-messages">
       <b-row class="no-gutters-md">
         <b-col cols="12">
           <div class="bg-color-light-purple hotels-messages__no-availability">
             <div><i class="icon-no-availability"></i></div>
             <div>
               <p class="text-14 color-black mb-0 font-bold">{{ translate('desNoResultsTitle') }}</p>
               <p class="text-14 color-black mb-0 hotels-messages__description">{{ translate('desNoResultsDescription') }}</p>
             </div>
           </div>
         </b-col>
       </b-row>
     </div>

 </b-container>

</template>

<script>
export default {
  name: 'HotelsNoAvailabilityMessage'
}
</script>
